
export const ENV = import.meta.env.VITE_SECRET_KEY
import CryptoJS from 'crypto-js';
export const isAuthenticated = () => {
  return localStorage.getItem('token') !== null && localStorage.getItem('token') !== undefined;
};

export async function encryption(obj, secret) {
  const iv = CryptoJS.lib.WordArray.random(16);
  const key = CryptoJS.enc.Utf8.parse(secret);
  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(obj), key, { iv });
  return `${CryptoJS.enc.Base64.stringify(iv)}:${encrypted.toString()}`;
}

export async function decryption(str, secret) {
  try {
    if (str) {
      const [ivStr, encryptedStr] = str.split(":");
      const iv = CryptoJS.enc.Base64.parse(ivStr);
      const key = CryptoJS.enc.Utf8.parse(secret);
      const decrypted = CryptoJS.AES.decrypt(encryptedStr, key, { iv });

      return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
    }
  } catch (e) {
    console.error("Decryption failed:", e);
    localStorage.removeItem('id');
  }
}

export async function saveToLocalStorage(key, obj) {
  const encryptedData = await encryption(obj, ENV);
  localStorage.setItem(key, encryptedData);
}

export function getFromLocalStorage(key) {
  const encryptedData = localStorage.getItem(key);
  if (encryptedData) {
    return decryption(encryptedData, ENV);
  }
  return null;
}